import { render, staticRenderFns } from "./TransfersIn.vue?vue&type=template&id=1e395490&scoped=true&"
import script from "./TransfersIn.vue?vue&type=script&lang=js&"
export * from "./TransfersIn.vue?vue&type=script&lang=js&"
import style0 from "./TransfersIn.vue?vue&type=style&index=0&id=1e395490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e395490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VForm,VRow})
